var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "row no-gutters align-items-center px-4 pb-lg-2 pb-3",
      class: _vm.isLast ? "" : "column-divider-bottom mb-2",
    },
    [
      _c("div", { staticClass: "col-lg-6 col-8 justify-content-start" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12 pl-2" },
            [
              _c(
                "a",
                {
                  staticClass: "small text-primary bold btn-view-app",
                  attrs: {
                    href: _vm.applicationLink(
                      _vm.applicationId,
                      _vm.clientUsername,
                      _vm.agentUsername
                    ),
                  },
                  on: {
                    click: function ($event) {
                      return _vm.logAmplitudeEvent("application link")
                    },
                  },
                },
                [
                  _c("span", [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("application.applicationID")) +
                        ":\n            " +
                        _vm._s(_vm.applicationId) +
                        "\n            "
                    ),
                    _vm.filogixId
                      ? _c("span", { staticClass: "ml-1" }, [
                          _vm._v("(" + _vm._s(_vm.filogixId) + ")"),
                        ])
                      : _vm._e(),
                  ]),
                ]
              ),
              _vm._v(" "),
              _vm.deleting
                ? _c("span", [
                    _c("i", {
                      staticClass:
                        "fa fa-circle-o-notch fa-spin text-danger ml-2",
                      attrs: { "aria-hidden": "true" },
                    }),
                  ])
                : _c("inline-prompt", {
                    staticClass: "d-inline-block ml-2 delete-application",
                    attrs: {
                      disabled: _vm.isViewOnly,
                      "confirmation-text": "i18n|messages.allDataWillBeLost",
                    },
                    on: {
                      accept: function ($event) {
                        return _vm.removeApplication()
                      },
                    },
                  }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.shared
            ? _c("div", { staticClass: "col-12 pl-0" }, [
                _c(
                  "p",
                  {
                    staticClass:
                      "small text-gray w-100 mb-0 regular-line-height px-2",
                  },
                  [
                    _c(
                      "i18n",
                      {
                        attrs: {
                          path: _vm.application.locked
                            ? "tables.messages.clientLockedAccess"
                            : "tables.messages.clientHasAccess",
                          tag: "span",
                          for: "global.words.access",
                        },
                      },
                      [
                        _c("span", { staticClass: "text-primary bold" }, [
                          _vm._v(_vm._s(_vm.$t("global.words.access"))),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c("icon", {
                      staticClass: "text-primary bold",
                      attrs: { name: "check" },
                    }),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.application.erdExpertApplicationId
            ? _c("div", { staticClass: "col-12 pl-0" }, [
                _c(
                  "p",
                  {
                    staticClass:
                      "small text-gray w-100 mb-0 regular-line-height px-2",
                  },
                  [
                    _c("span", { staticClass: "bold" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("filogix.expertSync.linkedIDFromExpert")
                        ) + ":\n          "
                      ),
                    ]),
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.application.erdExpertApplicationId) +
                        "\n        "
                    ),
                  ]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "col-12 pl-0" }, [
            _c(
              "p",
              {
                staticClass:
                  "small text-gray w-100 mb-0 regular-line-height px-2",
              },
              [
                _c("span", { staticClass: "bold" }, [
                  _vm._v(_vm._s(_vm.$t("tables.columns.createdOn")) + ": "),
                ]),
                _vm._v(
                  "\n          " +
                    _vm._s(_vm._f("formatDateHour")(_vm.createdAt)) +
                    "\n          "
                ),
                _c("span", { staticClass: "small text-capitalize" }, [
                  _vm._v(
                    "\n            (" +
                      _vm._s(_vm._f("formatTimeAgo")(_vm.createdAt)) +
                      ")\n          "
                  ),
                ]),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-12 pl-0" }, [
            _c(
              "p",
              {
                staticClass:
                  "small text-gray w-100 mb-0 regular-line-height px-2",
              },
              [
                _c("span", { staticClass: "bold" }, [
                  _vm._v(_vm._s(_vm.$t("tables.columns.source")) + ": "),
                ]),
                _vm._v(" "),
                _vm.applicationSource
                  ? _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.applicationSourceMessage(
                            _vm.coBrokeredFrom,
                            _vm.applicationSource
                          )
                        )
                      ),
                    ])
                  : _c("span", [_vm._v("N/A")]),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-12 pl-0" }, [
            _c(
              "p",
              {
                staticClass:
                  "small text-gray w-100 mb-0 regular-line-height px-2",
              },
              [
                _c("span", { staticClass: "bold" }, [
                  _vm._v(_vm._s(_vm.$t("global.words.status")) + ": "),
                ]),
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.$t("application.status." + _vm.applicationStatus)
                    ) +
                    "\n        "
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "col-12 pl-0 justify-content-left consent-status-container",
              class: { clickable: !_vm.getConsentObtainedDate },
              attrs: {
                id: "consent-status-container",
                "data-toggle": _vm.getConsentObtainedDate ? "" : "dropdown",
              },
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "small text-gray mb-0 regular-line-height px-2 row no-gutters",
                },
                [
                  _c("span", { staticClass: "bold" }, [
                    _vm._v(
                      _vm._s(_vm.$t("tables.columns.consentStatus")) +
                        _vm._s(_vm.consentObtainedDate ? ":" : "")
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.getConsentObtainedDate
                    ? _c("span", { staticClass: "ml-1" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$t(
                                "application.listing.consentObtainedFromClient"
                              )
                            ) +
                            " -\n            " +
                            _vm._s(
                              _vm._f("formatDate")(_vm.getConsentObtainedDate)
                            ) +
                            "\n          "
                        ),
                      ])
                    : _c(
                        "span",
                        { staticClass: "d-flex flex-row" },
                        [
                          _c("consent-status-info"),
                          _vm._v(" "),
                          _vm.editable
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "consent-status-dropdown dropdown",
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "grey-text text-darken-4 clickable arrow-consent-dropdown d-flex flex-row align-items-center",
                                      attrs: { disabled: _vm.isViewOnly },
                                    },
                                    [
                                      _c("span", { staticClass: "ml-1" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("application.listing")[
                                              _vm.getConsentStatus(
                                                _vm.consentStatus
                                              )
                                            ]
                                          )
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "i",
                                        { staticClass: "material-icons" },
                                        [_vm._v("arrow_drop_down")]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "dropdown-menu" }, [
                                    _c(
                                      "a",
                                      {
                                        staticClass:
                                          "dropdown-item clickable btn primary",
                                        class: {
                                          disabled:
                                            _vm.disableStatus(
                                              _vm.consentStatus,
                                              "not-obtained"
                                            ) || _vm.isViewOnly,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.updateConsentStatus(
                                              "not-obtained",
                                              _vm.applicationId,
                                              _vm.clientUsername
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm.consentStatus === "not-obtained"
                                          ? _c(
                                              "i",
                                              {
                                                staticClass: "material-icons",
                                                staticStyle: {
                                                  top: "3px",
                                                  "font-size":
                                                    "12px !important",
                                                },
                                                attrs: {
                                                  "aria-hidden": "true",
                                                },
                                              },
                                              [_vm._v("done")]
                                            )
                                          : _vm._e(),
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.$t("application.listing")[
                                                "not-obtained"
                                              ]
                                            ) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        staticClass:
                                          "dropdown-item clickable btn primary",
                                        class: {
                                          disabled: _vm.isViewOnly,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.updateConsentStatus(
                                              "obtained",
                                              _vm.applicationId,
                                              _vm.clientUsername
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm.consentStatus === "obtained"
                                          ? _c(
                                              "i",
                                              {
                                                staticClass: "material-icons",
                                                staticStyle: {
                                                  top: "3px",
                                                  "font-size":
                                                    "12px !important",
                                                },
                                                attrs: {
                                                  "aria-hidden": "true",
                                                },
                                              },
                                              [_vm._v("done")]
                                            )
                                          : _vm._e(),
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.$t(
                                                "application.listing.obtained"
                                              )
                                            ) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-12 pl-0" },
            [
              _c(
                "inline-prompt",
                {
                  staticClass: "d-inline-block",
                  attrs: {
                    disabled: _vm.isViewOnly,
                    "confirmation-text": "i18n|messages.confirmCopyApplication",
                  },
                  on: {
                    accept: function ($event) {
                      return _vm.$emit(
                        "open-modal",
                        _vm.applicationStreet,
                        _vm.applicationId,
                        _vm.application.currentMainApplicantAddress,
                        _vm.application.documentCount
                      )
                    },
                  },
                },
                [
                  _c(
                    "a",
                    {
                      staticClass:
                        "clickable text-primary bold copy-client small regular-line-height",
                      class: { disabled: _vm.isViewOnly },
                    },
                    [
                      _vm._v(
                        "\n            + " +
                          _vm._s(
                            _vm.$t("application.listing.copyApplication")
                          ) +
                          "\n          "
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _vm.localCopyingApp
                ? _c("inline-loader", {
                    staticClass: "mx-2",
                    attrs: { width: "16px", height: "16px" },
                  })
                : _vm._e(),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "col-lg-6 col-12 d-flex flex-row pr-0 mt-lg-0 mt-3 justify-content-end",
        },
        [
          _c(
            "a",
            {
              staticClass: "btn-view-app",
              attrs: {
                href: _vm.applicationLink(
                  _vm.applicationId,
                  _vm.clientUsername,
                  _vm.agentUsername
                ),
              },
              on: {
                click: function ($event) {
                  return _vm.logAmplitudeEvent("application")
                },
              },
            },
            [
              _c("div", { staticClass: "btn bold btn-white btn-sm" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("application.listing.openApplication")) +
                    "\n      "
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "btn-view-app ml-2",
              attrs: {
                href: _vm.documentApplicationLink(
                  _vm.applicationId,
                  _vm.clientUsername,
                  _vm.agentUsername
                ),
              },
              on: {
                click: function ($event) {
                  return _vm.logAmplitudeEvent("documents")
                },
              },
            },
            [
              _c("div", { staticClass: "btn bold btn-white btn-sm" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("application.listing.openDocuments")) +
                    "\n      "
                ),
              ]),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }